import { Helmet } from "react-helmet-async";
import ContractsView from "../../../components/dashboard/contracts/ContractsView";

export default function Contracts() {

    return <>
        <Helmet>
            <title>Contracts | Platform Solutions</title>
        </Helmet>

        <ContractsView />
    </>;
}
